module.exports = __webpack_public_path__ + "img/AL.2c8c9309.png";